import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";

interface DateRangeProps {
  onDateChange: (singleDate: Date | null) => void;
}

const SingleDate: React.FC<DateRangeProps> = ({ onDateChange }) => {
  const [singleDate, setSingleDate] = useState<Date | null>(new Date());

  useEffect(() => {
    onDateChange(singleDate);
  }, [singleDate]);

  const changeStartDate = (newStartDate: Date | null) => {
    if (newStartDate) {
      setSingleDate(newStartDate);
    }
  };

  return (
    <Form.Group controlId="daterange" className="my-2" style={{ width: "100%", marginTop: "10px" }}>
      <Form.Label className="font-semibold">Date</Form.Label>
      <div className="date-picker calendar-picker d-flex align-items-center">
        <DatePicker
          selected={singleDate}
          onChange={changeStartDate}
          className="form-control form-control-md text-center"
          //maxDate={new Date()}
          placeholderText="Select start date"
        />
      </div>
    </Form.Group>
  );
};

export default SingleDate;
